import { call, fork, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import SchemaClient from 'rest/SchemaClient';
import { errorAction } from 'components/utility/actions';
import * as actions from './actions';

const schemaClient = new SchemaClient();

export function doFetchSchemas() {
	return schemaClient.getAll().then(
		(response) => response.data.reduce(
			(col, cur) => {
				col[cur.id] = cur;
				return col;
			},
			{}
		)
	);
}

export function *fetchSchemas(action) {
	try {
		const data = yield call(doFetchSchemas);
		yield put({ type: actions.FETCH_SCHEMAS_SUCCESS, payload: data });
	} catch (error) {
		yield put(errorAction(actions.FETCH_SCHEMAS_ERROR, error, action));
	}
}

export default function *sagas() {
	yield fork(takeLatest, actions.FETCH_SCHEMAS, fetchSchemas);
}
